import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import useNativeListener from '@hooks/useNativeListener';
import { useQuery } from '@tanstack/react-query';
import {
    checkPermission, getLocation, Permission, requestPermission,
} from '@utils/nativeUtils';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { locationAgreedAtom, userLatLonAtom } from '../atoms/shopsInMapAtoms';

interface ILocation {
    lat: number,
    lon: number,
}

function useLocation() {
    const { t } = useTranslation('shopList');
    const toast = useToast();
    const [locationAgreed, setLocationAgreed] = useAtom(locationAgreedAtom);
    const setLocation = useSetAtom(userLatLonAtom);
    const [ready, setReady] = useState<boolean>(false);
    const { data: user } = useQuery(queries.user.detail());

    useNativeListener('getLocation', (result: ILocation) => {
        console.log('getLocation', { result });
        if (result && (user?.locationAgreed || !user)) {
            setLocation(result);
        }
        setLocationAgreed(!!result && (!!user?.locationAgreed || !user));
        setReady(true);
    }, [user]);

    useNativeListener('checkPermission', (permission: Permission, hasPermission: boolean) => {
        console.log('checkPermission', { permission, hasPermission });
        if (user?.locationAgreed || !user) {
            if (permission === Permission.LOCATION && hasPermission) {
                getLocation();
            } else if (permission === Permission.LOCATION) {
                requestPermission(Permission.LOCATION);
            }
        }
    }, [user]);

    useNativeListener('requestPermission', (permission: Permission, result: boolean) => {
        console.log('requestPermission', { permission, result });
        if (permission === Permission.LOCATION) {
            setLocationAgreed(result);
            if (result) {
                toast.success(t('toast.locationAllowed'));
            }
            getLocation();
        }
    });

    useEffect(() => {
        if (!user) {
            checkPermission(Permission.LOCATION);
        } else if (user.locationAgreed) {
            checkPermission(Permission.LOCATION);
        } else {
            setLocationAgreed(false);
            setReady(true);
        }
    }, [user]);

    return {
        locationAgreed, ready,
    };
}

export default useLocation;
